import { db } from "../firebase/config";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  query,
  orderBy,
  limit,
  where,
} from "firebase/firestore";

const BACKUP_COLLECTION = "HomeContent_Backups";

export const backupService = {
  // Modified to include parent section ID
  async createBackup(sectionId, parentSectionId, oldData, userId = "system") {
    try {
      const backupRef = doc(collection(db, BACKUP_COLLECTION));
      const backupData = {
        sectionId, // e.g., 'hero'
        parentSectionId, // e.g., 'home'
        data: oldData,
        timestamp: new Date().toISOString(),
        type: "section_update",
        userId,
        status: "active",
      };

      await setDoc(backupRef, backupData);
      return backupRef.id;
    } catch (error) {
      console.error("Error creating backup:", error);
      throw error;
    }
  },

  // Modified to search by both IDs
  async getBackups(sectionId, parentSectionId) {
    try {
      const q = query(
        collection(db, BACKUP_COLLECTION),
        where("sectionId", "==", sectionId),
        where("parentSectionId", "==", parentSectionId),
        orderBy("timestamp", "desc")
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    } catch (error) {
      console.error("Error fetching backups:", error);
      throw error;
    }
  },

  // Get a specific backup
  async getBackup(backupId) {
    try {
      const backupRef = doc(db, BACKUP_COLLECTION, backupId);
      const backupSnap = await getDoc(backupRef);

      if (!backupSnap.exists()) {
        throw new Error("Backup not found");
      }

      const backupData = {
        id: backupSnap.id,
        ...backupSnap.data(),
      };
      return backupData;
    } catch (error) {
      console.error("Error fetching backup:", error);
      throw error;
    }
  },

  // Get latest backup for a section
  async getLatestBackup(sectionId) {
    try {
      const q = query(
        collection(db, BACKUP_COLLECTION),
        where("sectionId", "==", sectionId),
        orderBy("timestamp", "desc"),
        limit(1)
      );

      const querySnapshot = await getDocs(q);
      if (querySnapshot.empty) {
        return null;
      }

      const doc = querySnapshot.docs[0];
      return {
        id: doc.id,
        ...doc.data(),
      };
    } catch (error) {
      console.error("Error fetching latest backup:", error);
      throw error;
    }
  },
};
